import typeAndSearch from './typeAndSearch'
import buttonNameCertification from './buttonNameCertification'

const users = {
  typeAndSearch,
  buttonNameCertification,
}

export default users
